import React, { useContext, useState, forwardRef } from 'react';
import { TextareaAutosize, Button, Select, MenuItem } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import styles from './index.module.scss';
import AdvanceMenuContext from '../../contexts/advance-menu-context';

const MainInput = forwardRef((props: any, ref: any) => {
    const items = [
        { label: "Project", value: 1 },
        { label: "Milestone", value: 2 },
        { label: "Announcement", value: 3 },
    ];

    const [eventTypeSelected, setEventTypeSelected] = useState<number>(1); 
    const onChangeEventType = (event: React.ChangeEvent<{ name?: string, value: unknown }>) => {
        setEventTypeSelected(event.target.value as number);
    };

    const { showMenu, setShowMenu } = useContext(AdvanceMenuContext);
    const onClickAddEvent = () => {
        setShowMenu(true);
    }

    return (
        <div className={styles.container} ref={ref}>
            <div className={styles.message}>
                <Select className={styles.postType}
                        value={eventTypeSelected}
                        onChange={onChangeEventType}
                        inputProps={{
                            name: 'age',
                            id: 'filled-age-native-simple'
                        }}>
                    {items.map((item, i) => <MenuItem value={item.value} key={i}>{item.label}</MenuItem>)}
                </Select>
                <TextareaAutosize className={styles.input}
                        placeholder="Type your message here" />
            </div>

            
            <Button variant="contained" color="primary" className={styles.addButton}>
                <AddIcon onClick={onClickAddEvent} />
            </Button>
        </div>
    );
});

export default MainInput;